import React, {FC} from 'react';
import {Route, Routes} from 'react-router-dom';

import {GlobalStyles} from '../../../libs/shared/ui/src/styles/globalStyles';
import {PageNotFoundError} from './common/pageNotFoundError';
import {surveyRoutes} from './survey/surveyRoutes';

/*
 * Component.
 */

export const App: FC = () => (
  <>
    <GlobalStyles />
    <Routes>
      {surveyRoutes}
      <Route path="*" element={<PageNotFoundError />} />
    </Routes>
  </>
);
